import { render, staticRenderFns } from "./ttSearchSetting.vue?vue&type=template&id=b2d3c4e4&"
import script from "./ttSearchSetting.vue?vue&type=script&lang=js&"
export * from "./ttSearchSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports